class PdpAccordion extends HTMLElement {
  constructor() {
    super();
    this.handleSummaryClick = this.handleSummaryClick.bind(this);
  }

  connectedCallback() {
    this.detailsElements = Array.from(this.querySelectorAll('details'));
    this.detailsElements.forEach((details) => this.setupDetails(details));
  }

  disconnectedCallback() {
    this.detailsElements?.forEach((details) => {
      const summary = this.getSummary(details);
      if (summary) {
        summary.removeEventListener('click', this.handleSummaryClick);
      }
    });
  }

  setupDetails(details) {
    const summary = this.getSummary(details);
    const content = this.getContent(details);

    if (!summary || !content) return;

    summary.addEventListener('click', this.handleSummaryClick);

    details.dataset.accordionState = details.hasAttribute('open') ? 'expanded' : 'collapsed';
    content.style.height = details.hasAttribute('open') ? 'auto' : '0px';
    content.style.opacity = details.hasAttribute('open') ? '1' : '0';
  }

  getSummary(details) {
    return Array.from(details.children).find((child) => child.tagName === 'SUMMARY');
  }

  getContent(details) {
    return Array.from(details.children).find(
      (child) =>
        child.classList.contains('pdp-accordion__content') ||
        child.classList.contains('pdp-accordion__subitem-content')
    );
  }

  handleSummaryClick(event) {
    event.preventDefault();

    const summary = event.currentTarget;
    const details = summary.parentElement;
    const content = this.getContent(details);

    if (!details || !content || details.dataset.animating === 'true') return;

    if (details.hasAttribute('open')) {
      this.collapse(details, summary, content);
      return;
    }

    this.expand(details, summary, content);
  }

  expand(details, summary, content) {
    details.dataset.animating = 'true';
    details.dataset.accordionState = 'expanding';
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');

    content.style.height = '0px';
    content.style.opacity = '0';

    const targetHeight = content.scrollHeight;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.height = `${targetHeight}px`;
        content.style.opacity = '1';
      });
    });

    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'height') return;

      content.removeEventListener('transitionend', onTransitionEnd);
      content.style.height = 'auto';
      details.dataset.animating = 'false';
      details.dataset.accordionState = 'expanded';
    };

    content.addEventListener('transitionend', onTransitionEnd);
  }

  collapse(details, summary, content) {
    details.dataset.animating = 'true';
    details.dataset.accordionState = 'collapsing';
    summary.setAttribute('aria-expanded', 'false');

    content.style.height = `${content.scrollHeight}px`;
    content.style.opacity = '1';
    content.offsetHeight;

    requestAnimationFrame(() => {
      content.style.height = '0px';
      content.style.opacity = '0';
    });

    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'height') return;

      content.removeEventListener('transitionend', onTransitionEnd);
      details.removeAttribute('open');
      details.dataset.animating = 'false';
      details.dataset.accordionState = 'collapsed';
    };

    content.addEventListener('transitionend', onTransitionEnd);
  }
}

if (!customElements.get('pdp-accordion')) {
  customElements.define('pdp-accordion', PdpAccordion);
}
